import EditOption from './EditOption.component';

export default EditOption;
